import {post} from '@/utils/request';
//获取验证码
export async function getVerficationCode(params) {
    return post('/login/sendVerficationCode', params, true)
}
//验证码success
export async function getvalidatecode(params) {
    return post('/login/validateCode', params, true)
}
export async function getupdatePwd(params) {
    return post('/login/updatePwd', params, true)
}
export async function getUserLogin(params) {
    return post('/login/getUserLogin', params, true)
}